import { faExternalLinkSquareAlt, faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  Button,
  Card,
  Col,
  Container,
  Row,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Fade from 'react-reveal/Fade';

const ProjectCard = () => {
  const title = {
    fontFamily: "'Satisfy', cursive",
    color: "#033d44",
  };
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("./Data.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);
  return (
    <Container fluid id="projects" className="pt-5 mt-5">
      <h1
        className="display-1 fw-bold ps-2 text-center mb-5 pb-5"
        style={title}
      >
        My Projects
      </h1>
      <Row xs={1} md={2} lg={3} className="g-5 px-5 pb-5 bg-color">
        {projects.map((project) => (
          <Col className="h-100" key={project.name}>
            <Fade big cascade>
              <Card className="h-100">
                <Card.Img variant="top" src={project.imgHome} />
                <Card.Body style={{ backgroundColor: "#cde4e7" }}>
                  <Card.Title>{project.name}</Card.Title>
                  <Card.Text style={{ textAlign: "justify" }}>
                    {project.description}
                  </Card.Text>
                </Card.Body>
                <Card.Footer style={{ backgroundColor: "#83bdc3" }}>
                  <ButtonGroup className="d-flex ">
                    <Button variant="outline-dark">
                      <FontAwesomeIcon
                        style={{
                          color: "#033d44",
                          fontWeight: "bold",
                          marginRight: "2px",
                        }}
                        icon={faExternalLinkSquareAlt}
                      />{" "}
                      <a
                        href={project.liveWebsite}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="custom-btn"
                      >
                        <span classname="fs-6 d-none d-sm-block">Preview</span>
                      </a>
                    </Button>
                    <Button variant="outline-dark">
                      <FontAwesomeIcon
                        style={{
                          color: "#033d44",
                          fontWeight: "bold",
                          marginRight: "10px",
                        }}
                        icon={faInfo}
                      />
                      <NavLink
                        className="custom-btn"
                        to={`/project/${project.name}`}
                      >
                        <span classname="fs-6 d-none d-sm-block">Details</span>
                      </NavLink>
                    </Button>
                  </ButtonGroup>
                </Card.Footer>
              </Card>
            </Fade>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ProjectCard;
